import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

export default function Loader () {
  return (
    <SkeletonTheme>
      <Skeleton
        count={3}
        width={'100%'}
        height={100}
        style={{ borderRadius: 16, marginBottom: 20 }}
      />
    </SkeletonTheme>
  )
}
